import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const ThankYou = () => (
  <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--pastel-mint))]">
    <div className="text-center px-6 max-w-md animate-fade-up">
      <CheckCircle className="mx-auto h-14 w-14 text-foreground" />
      <h1 className="mt-5 heading-bold text-4xl text-foreground sm:text-5xl">You're in!</h1>
      <p className="mt-4 text-base text-foreground/60 leading-relaxed sm:text-lg">
        Thanks for joining the waitlist. We'll reach out before launch day with early access and exclusive drops.
      </p>
      <Button asChild variant="hero" className="mt-8 h-[3.25rem] px-8 text-base">
        <Link to="/">Back to Home</Link>
      </Button>
    </div>
  </div>
);

export default ThankYou;
